<template>
  <v-layout wrap>
    <v-flex
      xs12
      v-for="(item, index) in enterprises"
      :key="`enterprise${index}`"
      style="margin-bottom: 10px"
      :style="{ 'color' : item.Color }"
    >
      <v-card
        class="mx-auto"
        :color="item.BGColor"
        :elevation="item.ID === enterpriseID ? 5 : 0"
        :style="{ 'opacity': item.ID === enterpriseID ? '1' : '0.8' }"
        dark
        max-width="400"
        @click="onChangeEnterprise(item, false)"
      >
      <v-layout wrap>
        <v-flex xs9 style="padding:20px 0 20px 20px">
          <!-- <v-icon
            large
            left
            style="font-size:30px;"
          >
            mdi-cellphone-text
          </v-icon> -->
          <span class="title" style="font-size:22px !important;font-weight: 300"
            :style="{ 'color' : item.Color }">{{item.Name}}</span>
        </v-flex>
        <v-flex xs3 style="padding:20px 15px 20px 0;text-align: right">
          <v-tooltip
            bottom
          >
            <template v-slot:activator="{ on }">      
              <v-btn v-if="!hideSettings" class="mx-2" fab dark small :color="item.Color && item.Color.length >= 7 ? item.Color.substring(0, 7).concat('33') : '#CCCCCC'"
                :elevation="0"
                @click.stop.prevent="onChangeEnterprise(item, true)"
                v-on="on"
              >
                <v-icon :color="item.Color">mdi-cellphone-cog</v-icon>
              </v-btn>
            </template>
            <span 
              :style="{ 'color' : item.Color }"
            >{{ $t('menus.title') }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <v-divider />
      <enterprises-menulmd v-if="userID !== 'd69d1760-72c4-4ed6-a588-f66cda47dd34'" :data="item" />
      <v-layout wrap v-if="item.LMD">
        <v-flex xs12 style="padding:10px 0 10px 25px" 
          :style="{ 'color' : item.Color }">
          <h5 style="font-weight:400;">{{$t('dashboard.lastModification')}} :</h5>
          <h5 style="font-weight:300;">{{getDate(item.LMD)}}</h5>
          <h5 style="font-weight:300;">PDF : https://menu.dview.es/assets/menus/{{item.ID}}.pdf</h5>
        </v-flex>
        <!-- <v-flex xs3 style="padding:10px 15px 10px 0;text-align: right">
          <v-btn class="mx-2" fab dark small :color="item.BGColorSecundary.substring(0,7).concat('33')"
            :elevation="0"
            @click="onChangeEnterprise(item, false)"
          >
            <v-icon :color="item.BGColorSecundary">mdi-chart-timeline-variant</v-icon>
          </v-btn>
        </v-flex> -->
      </v-layout>      
      <v-divider />
        <!-- <v-divider 
          style="margin-top:10px;margin-bottom:10px"
        />
        <h5 style="font-weight:300;padding-left: 20px">{{$t('dashboard.lastModification')}} :</h5>
        <h5 style="font-weight:300;padding-left: 20px">{{getDate(item.LMD)}}</h5> -->
        <!-- <v-divider 
          style="margin-top:10px;"
        /> -->
        <h5 
          :style="{ 'color' : item.Color }"
          style="font-weight:400;padding-top: 10px;padding-left: 20px">{{$t('dashboard.content')}} :</h5>
        <v-card-actions
          style="padding:0px !important;"
        >
          <v-list-item class="grow">
            <v-row
              align="center"
              style="padding: 10px 15px 15px 15px;"
              v-if="item.Permission"
            >
              <v-tooltip
                bottom
                v-for="(permission, indexPermission) in JSON.parse(item.Permission).filter(x=> x > 0)"
                :key="`permission${index}_${indexPermission}`"
              >
                <template v-slot:activator="{ on }">
                  <div style="width:31px;height:30px">
                    <v-icon
                      class="mr-1"
                      style="font-size: 25px;opacity:0.4;"
                      :style="{ 'color' : item.Color }"
                      v-on="on"
                    >
                      {{getPermission(permission)}}
                    </v-icon>
                    <!-- {{getPermissionName(permission)}} -->
                  </div>
                </template>
                <span 
                  :style="{ 'color' : item.Color }">{{ getPermissionName(permission) }}</span>
              </v-tooltip>
              <!-- <v-icon
                class="mr-1"
                v-for="(permission, indexPermission) in JSON.parse(item.Permission)"
                :key="`permission${index}_${indexPermission}`"
                style="font-size: 15px;"
              >
                {{getPermission(permission)}}
              </v-icon> -->
            </v-row>
          </v-list-item>
        </v-card-actions>
        <div 
          v-if="user && user.Permission.indexOf(5) >= 0"
        >
          <v-divider />
          <v-btn
            outlined
            small
            @click.stop.prevent="handleCloneEnterprise(item.ID)"
            style="margin:15px;"
            :color="item.Color && item.Color.length >= 7 ? item.Color.substring(0, 7).concat('80') : '#CCCCCC'"
          >
            {{$t('dashboard.cloneEnterprise')}}
          </v-btn>
        </div>
      </v-card>
      <!-- <v-btn
        dark
        block
        :color="item.BGColor"
        @click="handleChangeEnterprise(item)"
      >
        <span :style="{'color': item.Color}">{{ item.Name }}</span>
      </v-btn> -->
    </v-flex>
  </v-layout>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import EnterprisesMenulmd from './EnterprisesMenulmd'
  import api from '@/services/api'
  import utils from '@/services/utils'
  import constants from '@/constants'
  export default {
    components: {
      EnterprisesMenulmd
    },
    props: {
      data: {
        type: Array,
        required: true
      },
      user: {
        type: Object,
        required: false
      },
      onChangeEnterprise: {
        type: Function,
        required: true
      },
      onRefreshEnterprise: {
        type:Function,
        required: true
      }
    },
    data: () => ({
      enterprises: []
    }),
    computed: {
      ...mapState('app',['locale', 'enterpriseID', 'hideSettings']),
      // enterpriseID () {
      //   return utils.getActiveEnterpriseID(this)
      // },
      userID () {
        return utils.getUserID()
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor ? this.$store.state.app.enterpriseColor : 'dtouch'
      }
    },
    watch: {
      data (v) {
        if (v) this.enterprises = v
      }
    },
    mounted () {
      this.enterprises = this.data
    },
    methods: {
      getPermission (id) {
        const aux = constants.menuType.filter(x => x.id === id)
        return aux && aux.length > 0 ? aux[0].icon : ''
      },
      getPermissionName (id) {
        const aux = constants.menuType.filter(x => x.id === id)
        return aux && aux.length > 0 ? this.$t(`menuType.${aux[0].name}`) : ''
      },
      getDate (value) {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }
        if(value) return new Date(value).toLocaleDateString(this.locale, options)
        return ''
      },
      handleCloneEnterprise (id) {
        const body = {

        }
        api.updateItem('enterprises', `${id}/clone`, body).then(response => {
          this.onRefreshEnterprise()
        }).catch(function (error) {
          if (error.response.status === 403) {
            window.location.href = '/#/login'
          }
        })
      }
    }
  }
</script>

<style lang="postcss" scoped>
  .table-main {
    width: 100%;
  }
  .table-main td {
    vertical-align: top;
  }
  .table-main.body {
    width: auto;
  }
  .enterprises {
    width: 400px;
    padding: 0 5px 0px 20px;
  }
</style>

